/*  
This component gives out the side nav bar which gets rendered at every page (service inventory, platform dashboard, customer solution dashboard). 
This component is called by ServiceInventoryPage.js file, CsVersionPage.js file, PltVersionPage.js file.

This component shows the icons. So when clicked they are taken to respective page.
*/

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { FaHome } from "react-icons/fa";
import { MdInventory2  } from "react-icons/md";
import { GiPlatform } from "react-icons/gi";
import { AiOutlineSolution } from "react-icons/ai";
import { MdOutlineMonitorHeart } from "react-icons/md";
import { FaUsers } from "react-icons/fa6";
import './SideBar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="sidebar">
      <button 
        className={`home-button ${location.pathname === '/svc-inventory' ? 'active' : ''}`}
        onClick={() => handleNavigation('/svc-inventory')}
        data-tooltip="Service Inventory"
      >
        <MdInventory2  />
      </button>

      <button 
        className={`platform-dashboard ${location.pathname === '/plt-version' ? 'active' : ''}`}
        onClick={() => handleNavigation('/plt-version')}
        data-tooltip="Platform Version"
      >
        <GiPlatform />
      </button>

      <button 
        className={`cs-dashboard ${location.pathname === '/cs-version' ? 'active' : ''}`}
        onClick={() => handleNavigation('/cs-version')}
        data-tooltip="CS Version"
      >
        <AiOutlineSolution />
      </button>

      <button 
        className={`node-monitor ${location.pathname === '/node-usage' ? 'active' : ''}`}
        onClick={() => handleNavigation('/node-usage')}
        data-tooltip="Node Monitor"
      >
        <MdOutlineMonitorHeart />
      </button>

      <button 
        className={`node-monitor ${location.pathname === '/node-usage' ? 'active' : ''}`}
        onClick={() => handleNavigation('/harness-user')}
        data-tooltip="Harness User"
      >
        <FaUsers />
      </button>
    </div>
  );
};

export default Sidebar;